import { render, staticRenderFns } from "./LglPanel.vue?vue&type=template&id=7db2922c&"
import script from "./LglPanel.vue?vue&type=script&lang=js&"
export * from "./LglPanel.vue?vue&type=script&lang=js&"
import style0 from "./LglPanel.vue?vue&type=style&index=0&id=7db2922c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports